








import { Vue, Component, Prop } from 'vue-property-decorator';
import BaseH5 from '../base-headings/_base-h5.vue';
import type { EStatusType } from './types/status-type';

@Component({
  name: 'BaseStatusBadge',
  components: {
    BaseH5,
  },
})
export default class BaseStatusBadge extends Vue {
  @Prop() statusType: EStatusType;
  @Prop() text: string;
  @Prop() border: boolean;
  @Prop({ default: true }) enableMinWidth: boolean;
}
